<template>
  <div class="fb-view-card" :md-error="error" :id="element.uuid" v-if="mode">
    <md-card :class="saveData.type">
      <md-card-header class="text-left" v-if="saveData.type != 'video' && saveData.label">
        <div class="md-title">{{ saveData.label | token_replace(nid) }}</div>
      </md-card-header>

      <md-card-content>
        <component
          v-for="(el, index) in element.list"
          :uuid="el.uuid"
          :nid="nid"
          :sid="sid"
          :main_sid="main_sid"
          :key="el.uuid"
          :is="el.type"
          :element="el"
          :mode="1"
          :validate="validate"
          :active="active"
          :step="element.uuid"
          :countFormCards="countFormCards"
          :is-draft="isDraft"
          :status="status"
          :showSubmit="showSubmit"
          :validationFails="validation"
          :pmode="pmode"
          :gatekeeping="saveData.gatekeeping"
          @submit="$emit('submit')"
          @validate-form="$emit('validate-form')"
          @disable-form-validation="$emit('disable-form-validation')"
          @submit-draft="$emit('submit-draft', $event)"
          @autosave-start="$emit('autosave-start')"
          @autosave-stop="$emit('autosave-stop')"
          @validation="updateValidation(index, $event)"
          @set-value="$emit('set-value', $event)"
        ></component>
      </md-card-content>
    </md-card>
  </div>
  <md-card v-else class="md-elevation-2 md-layout-item md-primary fb-step">
    <fb-controll
      :controll="saveData.label || 'Card'"
      @collapse-click="collapsePreview"
      @setting-click="showSettings"
      @menu-delete="$emit('menu-delete')"
    />
    <md-content v-show="!collapse">
      <md-field>
        <label>{{ tempData.label | token_replace(nid) }}</label>
      </md-field>
      <draggable
        @change="updateList"
        class="dragArea full-height"
        tag="div"
        :list="list"
        group="controls"
        :class="{'show-draggable': !list.length}"
      >
        <component
          v-for="(element, index) in list"
          @save-data="updateData(index, $event)"
          @menu-delete="removeItem(index)"
          :uuid="element.uuid"
          :key="element.uuid"
          :is="element.type"
          :element="element"
          :mode="0"
          :validate="validate"
        ></component>
      </draggable>
    </md-content>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Label</label>
          <md-input v-model="tempData.label"></md-input>
        </md-field>
        <md-field class="fb-select">
          <label for="movie">Type</label>
          <md-select v-model="tempData.type">
            <md-option value="step">Step card</md-option>
            <md-option value="video">Video card</md-option>
            <md-option value="hurdle">Hurdle card</md-option>
            <md-option value="content">Content Hurdle card</md-option>
            <md-option value="alert">Alert card</md-option>
            <md-option value="form">Form card</md-option>
            <md-option value="document">Document card</md-option>
            <md-option value="plain">Plain card</md-option>
          </md-select>
        </md-field>
        <md-checkbox v-model="tempData.gatekeeping">Require consecutive order on form steps</md-checkbox><br/>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import FbStep from "./FbStep.vue";

export default {
  name: "FbCard",
  props: [
    "element",
    "mode",
    "stepIndex",
    "steps",
    "active",
    "validate-last-step",
    "countFormCards",
    "status",
    "showSubmit",
    "validate",
    "pmode"
  ],
  mixins: [FbStep],
  data() {
    return {
      tempData: {
        label: this.element.data.label || "",
        value: this.element.data.value || false,
        type: this.element.data.type || "step",
        gatekeeping: this.element.data.gatekeeping || false
      },
      saveData: {
        label: this.element.data.label || "",
        value: this.element.data.value || false,
        type: this.element.data.type || "step",
        gatekeeping: this.element.data.gatekeeping || false
      },
      validation: [],
      list: this.element.list || []
    };
  }
};
</script>

<style lang="scss" scoped>

.dragArea {
  padding-bottom: 10px;
  position: relative;
  z-index: 99;
  // &::before {
  //   content: "DragAndDrop";
  //   display: block;
  //   position: absolute;
  //   top: 50%;
  //   text-align: center;
  //   width: 100%;
  // }
  min-height: 100px;
  background-color: rgba(255, 255, 255, 0.05);
}
</style>

